// extracted by mini-css-extract-plugin
export default {"title":"SJ8KBM","container":"gH2mJk","avatar":"VMVlaG","form":"GKLJXq","textarea":"x9eF77","footer":"qOVv25","submit":"tMEDOb"};